import App from '/app/packages/app/pages/_app.tsx';
window.__REX_APP__ = App;
